export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_SINGLE_REQUEST = 'GET_SINGLE_REQUEST'
export const GET_USER_REQUEST_COUNT = 'GET_USER_REQUEST_COUNT'
